export type PageVisitGuideType =
  | "mailbox"
  | "sender"
  | "postmaster"
  | "emailHealth"
  | "inboxPlacement"
  | "integration"
  | "templates"
  | "team"
  | "role"
  | "mailboxLabel"
  | "senderProfileLabel"
  | "emailHealthLabel"
  | "postmasterLabel"
  | "templateLabel";

type PageVisitGuideConfig = {
  title: string;
  videos: {
    title: string;
    description: string;
    url: string;
  }[];
};

export const pageVisitGuideConfig: Record<
  PageVisitGuideType,
  PageVisitGuideConfig
> = {
  mailbox: {
    title: "Connect your mailbox",
    videos: [
      {
        title: "Connect Google Workspace to InboxDoctor",
        url: "https://www.youtube.com/embed/vNtEXgmV944",
        description:
          "Learn how to connect your Google Workspace account with InboxDoctor",
      },
      {
        title: "Connect Microsoft Outlook",
        url: "https://www.youtube.com/embed/Ta-TAuZ4-94",
        description:
          "Step-by-step guide to connect Microsoft Outlook with InboxDoctor",
      },
      {
        title: "Connect via IMAP/SMTP",
        url: "https://www.youtube.com/embed/foSSqoX4rtI",
        description: "Connect your mailbox using IMAP/SMTP settings",
      },
      {
        title: "Bulk Connect Google Workspace",
        url: "https://www.youtube.com/embed/wA4v056GTfI",
        description:
          "Learn how to connect multiple Google Workspace mailboxes at once",
      },
    ],
  },
  mailboxLabel: {
    title: "Mailbox Labels Guide",
    videos: [
      {
        title: "Mailbox Labels Guide",
        description: "Learn how to manage mailbox labels in InboxDoctor",
        url: "https://www.youtube.com/embed/cNdMyQV5O4c",
      },
    ],
  },
  senderProfileLabel: {
    title: "Sender Profile Labels Guide",
    videos: [
      {
        title: "Sender Profile Labels Guide",
        description: "Learn how to manage sender profile labels in InboxDoctor",
        url: "https://www.youtube.com/embed/ffudVh4QVug",
      },
    ],
  },
  emailHealthLabel: {
    title: "Email Health Labels Guide",
    videos: [
      {
        title: "Email Health Labels Guide",
        description: "Learn how to manage email health labels in InboxDoctor",
        url: "https://www.youtube.com/embed/pnYh02qlI48",
      },
    ],
  },
  postmasterLabel: {
    title: "Postmaster Labels Guide",
    videos: [
      {
        title: "Postmaster Labels Guide",
        description: "Learn how to manage postmaster labels in InboxDoctor",
        url: "https://www.youtube.com/embed/c4oNBBpJx0Y",
      },
    ],
  },
  templateLabel: {
    title: "Template Labels Guide",
    videos: [
      {
        title: "Template Labels Guide",
        description: "Learn how to manage template labels in InboxDoctor",
        url: "https://www.youtube.com/embed/v9wBGaTFTaA",
      },
    ],
  },
  sender: {
    title: "Add a sender profile",
    videos: [
      {
        title: "Seed Account Guide",
        description: "Learn how to manage sender profiles in InboxDoctor",
        url: "https://www.youtube.com/embed/ffudVh4QVug",
      },
    ],
  },
  postmaster: {
    title: "Add Google Postmaster Domain",
    videos: [
      {
        title: "Google Postmaster",
        description:
          "How to Set Up Google Postmaster Integration in InboxDoctor?",
        url: "https://www.youtube.com/embed/6oVeRVAO9KQ",
      },
    ],
  },
  emailHealth: {
    title: "Email Health Test Guide",
    videos: [
      {
        title: "Connected Mailbox Health Test",
        description:
          "How to Run an Email Health Test for Connected Mailboxes in InboxDoctor?",
        url: "https://www.youtube.com/embed/oNnenCL7k3k",
      },
      {
        title: "Non-Connected Mailbox Health Test",
        description:
          "How to Test Email Health for Non-Connected Mailboxes in InboxDoctor?",
        url: "https://www.youtube.com/embed/c_lAP0iVJBk",
      },
      {
        title: "Manual Bulk Health Test",
        description:
          "How to Run a Manual Bulk Email Health Test in InboxDoctor?",
        url: "https://www.youtube.com/embed/UAT-6RKVZcQ",
      },
    ],
  },
  inboxPlacement: {
    title: "Inbox Placement Test Guide",
    videos: [
      {
        title: "B2B Inbox Placement Test",
        description: "How to Run a B2B Inbox Placement Test in InboxDoctor?",
        url: "https://www.youtube.com/embed/veDGLqtWW3I",
      },
      {
        title: "B2C Inbox Placement Test",
        description: "How to Run a B2C Inbox Placement Test in InboxDoctor?",
        url: "https://www.youtube.com/embed/2DJXcAt7qIk",
      },
      {
        title: "Connected Seed Account Test",
        description: "B2B Inbox Placement Test on Connected Seed Account",
        url: "https://www.youtube.com/embed/C72c60yhZ4g",
      },
      {
        title: "Seed Account Test",
        description:
          "How to Run an Inbox Placement Test on Seed Account in InboxDoctor?",
        url: "https://www.youtube.com/embed/tyIjG459ykQ",
      },
    ],
  },
  integration: {
    title: "Integration Guide",
    videos: [
      {
        title: "Integration Guide",
        description: "How Integration work in InboxDoctor?",
        url: "https://www.youtube.com/embed/-cWEttGoW_Q",
      },
    ],
  },
  templates: {
    title: "Email Templates Guide",
    videos: [
      {
        title: "HTML Email Templates",
        description: "How to Create HTML Email Templates in InboxDoctor?",
        url: "https://www.youtube.com/embed/jU2E8UhE3D4",
      },
      {
        title: "Plain Text Email Templates",
        description: "How to Create Plain Text Email Templates in InboxDoctor?",
        url: "https://www.youtube.com/embed/Bcbd9AM66vU",
      },
    ],
  },
  team: {
    title: "Team Management Guide",
    videos: [
      {
        title: "Team Management",
        description: "How to Invite Team Members in InboxDoctor?",
        url: "https://www.youtube.com/embed/aVP2ZznQMeg",
      },
    ],
  },
  role: {
    title: "Role Management Guide",
    videos: [
      {
        title: "Role Management",
        description: "How to Create and Manage Team Roles in InboxDoctor?",
        url: "https://www.youtube.com/embed/VRKR0pQ9NvE",
      },
    ],
  },
};
